import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    noResultsMessage: 'text-center container'
  },
  defaultSearchTerm: 'Shoes',
  showDidYouMean: false,
  showSearch: true
} satisfies PagesConfig['search']
